export const KEY_BACKSPACE = "Backspace";
export const KEY_TAB = "Tab";
export const KEY_ENTER = "Enter";
export const KEY_SHIFT = "Shift";
export const KEY_CTRL = "Control";
export const KEY_ALT = "Alt";
export const KEY_PAUSE_BREAK = "Pause/Break";
export const KEY_CAPS_LOCK = "CapsLock";
export const KEY_ESC = "Escape";
export const KEY_SPACE = " ";
export const KEY_PAGE_UP = "PageUp";
export const KEY_PAGE_DOWN = "PageDown";
export const KEY_END = "End";
export const KEY_HOME = "Home";
export const KEY_LEFT_ARROW = "ArrowLeft";
export const KEY_UP_ARROW = "ArrowUp";
export const KEY_RIGHT_ARROW = "ArrowRight";
export const KEY_DOWN_ARROW = "ArrowDown";
export const KEY_INSERT = "Insert";
export const KEY_DELETE = "Delete";

export const KEY_0 = "0";
export const KEY_1 = "1";
export const KEY_2 = "2";
export const KEY_3 = "3";
export const KEY_4 = "4";
export const KEY_5 = "5";
export const KEY_6 = "6";
export const KEY_7 = "7";
export const KEY_8 = "8";
export const KEY_9 = "9";

export const KEY_NUMPAD_0 = "Numpad 0";
export const KEY_NUMPAD_1 = "Numpad 1";
export const KEY_NUMPAD_2 = "Numpad 2";
export const KEY_NUMPAD_3 = "Numpad 3";
export const KEY_NUMPAD_4 = "Numpad 4";
export const KEY_NUMPAD_5 = "Numpad 5";
export const KEY_NUMPAD_6 = "Numpad 6";
export const KEY_NUMPAD_7 = "Numpad 7";
export const KEY_NUMPAD_8 = "Numpad 8";
export const KEY_NUMPAD_9 = "Numpad 9";

export const KEY_MULTIPLY = "Multiply";
export const KEY_ADD = "Add";
export const KEY_SUBTRACT = "Subtract";
export const KEY_DECIMAL_POINT = "Decimal Point";
export const KEY_DIVIDE = "Divide";

export const KEY_A = "A";
export const KEY_B = "B";
export const KEY_C = "C";
export const KEY_D = "D";
export const KEY_E = "E";
export const KEY_F = "F";
export const KEY_G = "G";
export const KEY_H = "H";
export const KEY_I = "I";
export const KEY_J = "J";
export const KEY_K = "K";
export const KEY_L = "L";
export const KEY_M = "M";
export const KEY_N = "N";
export const KEY_O = "O";
export const KEY_P = "P";
export const KEY_Q = "Q";
export const KEY_R = "R";
export const KEY_S = "S";
export const KEY_T = "T";
export const KEY_U = "U";
export const KEY_V = "V";
export const KEY_W = "W";
export const KEY_X = "X";
export const KEY_Y = "Y";
export const KEY_Z = "Z";
